// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getQuoteDetails from "@bg/App/Handlers/CustomQuote/GetCustomQuote";
import { UpdateCustomQuoteLines, updateQuoteLine } from "@bg/App/Services/CustomQuoteService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Props {
    apiParameter: UpdateCustomQuoteLines;
    apiResult: { successful: boolean; error?: any };
}

type Parameter = UpdateCustomQuoteLines & {
    customQuoteId: string;
    onSuccess?: () => void;
    onComplete?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const BeginLoadingquotes: HandlerType = props => {
    props.dispatch({
        type: "Pages/MyCustomQuotes/BeginLoadingQuoteDetails",
    } as any);
};

export const DispatchBeginAction: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const CallApiWithParameters: HandlerType = async props => {
    props.apiResult = await updateQuoteLine(props.apiParameter);
};

export const OnError: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.dispatch({
            type: "Pages/MyCustomQuotes/CompleteLoadingQuoteDetails",
        } as any);
        props.parameter.onError?.(props.apiResult.error);
    }
};

export const CallOnComplete: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch(
            getQuoteDetails({
                quoteId: props.parameter.customQuoteId,
                skipPricingAndInventory: true,
                onComplete: (result: any) => {
                    if (result.successful) {
                        props.dispatch({
                            type: "Pages/MyCustomQuotes/UpdateLineQty",
                            lineModel: props.parameter.linesModel[0],
                        } as any);
                        props.parameter.onComplete?.(props.apiResult);
                    }
                },
            }),
        );
    }
};

export const chain = [BeginLoadingquotes, DispatchBeginAction, CallApiWithParameters, OnError, CallOnComplete];

const updateLineQty = createHandlerChainRunner(chain, "UpdateLineQty");
export default updateLineQty;
